export default "__VITE_ASSET__ul7owPKp__"